import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { EsLoginModule } from '@examsoft/es-login';
import { TranslationModule } from '@examsoft/translation';
import { NgxPaginationModule } from 'ngx-pagination';
import { environment } from '../environments/environment';
import { Dashboard } from './dashboard/index';
import { MainComponent } from './main/main.component';
import { PageNotFoundComponent } from './not-found.component';
import { AppRouteModule } from './route.module';
import { SharedModule } from './shared/shared.module';
import { UnavailableComponent } from './unavailable/unavailable.component';


@NgModule({
  declarations: [
    MainComponent,
    ...Dashboard,
    PageNotFoundComponent,
    UnavailableComponent
  ],
  imports: [
    NgxPaginationModule,
    BrowserModule,
    HttpClientModule,
    AppRouteModule,
    SharedModule,
    TranslationModule.forRoot({
      defaultLanguage: 'en',
      languages: {
        ar: { isRTL: true },
        es: { isRTL: false }
      }
    }),

    ReactiveFormsModule,
    EsLoginModule.forRoot(environment)
  ],
  bootstrap: [ MainComponent ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }
